import(/* webpackMode: "eager" */ "/app/apps/web/app/plans.tsx");
import(/* webpackMode: "eager" */ "/app/packages/core/index.ts")